import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=f6c45f50&scoped=true&lang=pug&"
import script from "./GlobalFooter.vue?vue&type=script&lang=ts&"
export * from "./GlobalFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=f6c45f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c45f50",
  null
  
)

export default component.exports